import React from 'react';
import styles from '../../../styles/portfolio/quote.scss';


export const Quote = props => {
    return (
        <div className={styles.container}>
            {/*<div className={styles.header}>*/}
            {/*    {props.header}*/}
            {/*</div>*/}
            <div className={styles.body}>
                {props.message}
            </div>
        </div>
    )
};
